import React from "react";
import { NumericFormat } from "react-number-format";

export interface PriceFormatProps {
  value?: number | null;
}

const PriceFormat = ({ value }: PriceFormatProps) => {
  return (
    <NumericFormat value={value} displayType="text" thousandSeparator=" " suffix="€" />
  );
};

export default PriceFormat;